import { useNavigate } from "react-router-dom";
import { jobService } from "services/job.service";
import userimg from "../../../assets/images/avatar.svg";
import star from "../../../assets/images/star.svg";
import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import useCurrentUser from "hooks/useCurrentUser";
import BioSection from "Dashboard/Dashboardpages/Bio";
import PilotDetailsModal from "../PilotDetailsModal";
// import './style.css'

function RequestDetails(props) {
  const { dataId, show, handleClose, setActiveTab, setShowBids } = props;
  const navigate = useNavigate();
  const [showForm, setShowForm] = useState(false);
  const [bidId, setBidId] = useState(false);
  const [bidAmount, setBidAmount] = useState(false);
  const [data, setData] = useState([]);
  const [showPilotModal, setShowPilotModal] = useState(false); // NEW
  const { user } = useCurrentUser();
  const homeData = JSON.parse(localStorage.getItem('homeData'));
  const getClientBidDetails = async () => {
    try {
      const response = await jobService.jobBidDetails(dataId);
      setData(response?.data?.data);
      setBidId(response?.data?.data?._id);
    } catch (err) {
      console.error(err?.response?.data?.message);
    }
  };

  const updateBidStatus = async (type) => {
    const payload = {
      jobBidId: bidId,
      status: type,
    };
    try {
      const response = await jobService.updateBidStatus(payload);
      setActiveTab && setActiveTab("InProgress");

      setShowBids(false);
      handleClose();
      navigate("/my-jobs");

      if (response?.data?.data?.bid?.status === "AcceptedByClient") {
        toast.success("Bid accepted successfully", { autoClose: 1000 });
      }
      if (response?.data?.data?.bid?.status === "RejectedByClient") {
        toast.success("Bid Rejected  successfully", { autoClose: 1000 });
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (parseFloat(bidAmount) > 0) {
      try {
        const payload = {
          jobBidId: bidId,
          bidAmount: bidAmount,
        };

        const response = await jobService.negotiateBid(payload);
        setData(response?.data);
        setShowForm(false);
        handleClose();
        setShowBids(false);
        toast.success("Bid negotiated successfully", { autoClose: 1000 });
      } catch (err) {
        console.log(err);
      }
    } else {
      toast.error("Bid amount should be greater than 0.");
    }
  };

  useEffect(() => {
    getClientBidDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataId]);

  const pilot = data?.pilotId || {};

  console.log("+++homeData", data)
  return (
    <>
      {/* MAIN REQUEST MODAL */}
      <Modal show={show} className="modal-common bid-request-modal-main" onHide={handleClose}>
        <Modal.Header closeButton>Request Details</Modal.Header>
        <Modal.Body>
          <div>
            {/* CLICKABLE PILOT HEADER TO OPEN DETAIL MODAL */}
            <div
              className="text-center mb-4"
              onClick={() => setShowPilotModal(true)}
              style={{ cursor: "pointer" }}
            >
              <img
                src={pilot?.avatar ? `${user?.baseS3Url}${pilot?.avatar}` : userimg}
                alt="user"
                className="modal-avatar"
              />
              <p className="mt-1 mb-0 fw-bold">{pilot?.fullName}</p>
              <p className="mb-0">
                <img src={star} className="me-2" alt="rating" />
                {pilot?.avgRating ? Math.round(pilot?.avgRating) : 0} Rating
              </p>
              <small className="text-muted d-block mt-1">
                Click for pilot details
              </small>
            </div>

            <div className="details-para">
              <h6 className="light-texts">Estimated (days)</h6>
              <p>{data?.estimationDays}</p>
            </div>

            <div className="details-para">
              <h6 className="light-texts">Message</h6>
              <p>{data?.message}</p>
            </div>

            {data?.pilotInitialBidAmount && (
              <div className="d-flex justify-content-between amount-div">
                <h5>Bid Amount ($)</h5>
                <p>{data?.pilotInitialBidAmount}</p>
              </div>
            )}

            {data?.clientNegotiatedBidAmount && (
              <div className="d-flex justify-content-between amount-div">
                <h5>User Negotiation Amount ($)</h5>
                <p>{data?.clientNegotiatedBidAmount}</p>
              </div>
            )}

            {data?.pilotNegotiatedBidAmount && (
              <div className="d-flex justify-content-between amount-div">
                <h5>Pilot Negotiation Amount ($)</h5>
                <p>{data?.pilotNegotiatedBidAmount}</p>
              </div>
            )}

            {data?.status && (
              <div className="d-flex justify-content-between amount-div">
                <h5>Status</h5>
                <p>{data?.status === "RejectedByClient" ? "Rejected" : data?.status}</p>
              </div>
            )}

            {!showForm &&
              data?.pilotInitialBidAmount &&
              !data?.clientNegotiatedBidAmount &&
              !data?.pilotNegotiatedBidAmount && (
                <div className="d-flex flex-wrap justify-content-between">
                  <button
                    className="border-0 gray-btn"
                    onClick={() => setShowForm(!showForm)}
                  >
                    Negotiate
                  </button>
                  <button
                    className="blue-btn border-0"
                    onClick={() => updateBidStatus("Accept")}
                  >
                    Accept
                  </button>
                </div>
              )}

            {data?.status === "RejectedByClient" ? null : (
              <>
                {data?.pilotNegotiatedBidAmount && data?.jobId?.status === "Pending" && (
                  <div className="d-flex flex-wrap justify-content-between">
                    <button
                      className="gray-btn border-0"
                      onClick={() => updateBidStatus("Reject")}
                    >
                      Reject
                    </button>
                    <button
                      className="blue-btn border-0"
                      onClick={() => updateBidStatus("Accept")}
                    >
                      Accept
                    </button>
                  </div>
                )}
              </>
            )}
          </div>

          <div className="my-4">
            {showForm && (
              <form onSubmit={handleSubmit}>
                <div className="mb-30">
                  <label className="py-2">Enter your negotiate amount ($)</label>
                  <br />
                  <input
                    type="text"
                    onChange={(e) => setBidAmount(e.target.value)}
                    className="form-control rounded-3 bg-cyan w-100"
                    required
                  />
                </div>

                <div className="d-flex flex-wrap justify-content-between">
                  <button
                    type="button"
                    className="border-0 gray-btn"
                    onClick={() => setShowForm(false)}
                  >
                    Cancel
                  </button>

                  <button type="submit" className="border-0 blue-btn">
                    Submit
                  </button>
                </div>
              </form>
            )}
          </div>
        </Modal.Body>
      </Modal>

      <PilotDetailsModal
        show={showPilotModal}
        onHide={() => setShowPilotModal(false)}
        pilot={pilot}
        portfolio={pilot?.portfolio}   // OR API response where this data lives
        baseS3Url={user?.baseS3Url}
      />


    </>
  );
}

export default RequestDetails;
